import { createGlobalStyle } from 'styled-components'

export const MobileContainerPadding = createGlobalStyle`
  @media (max-width: 768px) {
    .row.px-0.mx-0 > .container {
      padding: 90px 16px;
    }
  }
`
